import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  BoundaryEditSubmitModalContainer, type BoundaryEditSubmitModalContainerProps,
} from './boundaryEditSubmitModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    BoundaryEditSubmit: BoundaryEditSubmitModalContainerProps;
  }
}
modalRenderer.register('BoundaryEditSubmit', BoundaryEditSubmitModalContainer);
